import { useEffect, useState } from 'react'
import Iframe from 'react-iframe'
// import { InstagramEmbed } from 'react-social-media-embed'

function InstagramDemo() {
    // const [instagramUrl, setInstagramUrl] = useState(null)

    // useEffect(() => {
    //     setTimeout(() => {
    //         setInstagramUrl('https://www.instagram.com/p/DFMNHLrPrgS/?utm_source=ig_web_copy_link')
    //     }, 3000)
    // }, [])


    /*
    <!-- SnapWidget -->
<!-- SnapWidget -->
<iframe src="https://snapwidget.com/embed/1096643" class="snapwidget-widget" allowtransparency="true" frameborder="0" scrolling="no" style="border:none; overflow:hidden; border-radius:5px; width:500px; height:600px" title="Posts from Instagram"></iframe>
*/
    return (
        <Iframe
            // url={'https://www.instagram.com/p/DFMNHLrPrgS/embed'}
            url={'https://snapwidget.com/embed/1096643'}
            // class="snapwidget-widget"
            className='snapwidget-widget smsize:w-full smsize:h-[500px]'
            width="100%"
            height="600"
            frameBorder="0"
            scrolling="no"
            allowTransparency={true}
            allow="encrypted-media"
            style={{ border: 'none', overflow: 'hidden' }}
            title="Instagram post"
        />
    )
}

export default InstagramDemo